import { useContext, useEffect, useRef } from 'react'
import { AiToolsContainer } from './styles'
import { AiContext } from '../../../contexts/AiContext'
import { Brain } from '@phosphor-icons/react';

export const AiTools = () => {
  const { isAiToolsVisible, hideAiTools } = useContext(AiContext);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (isAiToolsVisible) {
        if (
          ref.current &&
          !ref.current.contains(event.target)
        ) {
          hideAiTools && hideAiTools();
        }
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [hideAiTools, isAiToolsVisible]);

  useEffect(() => {
    if (isAiToolsVisible && ref.current) {
      ref.current?.querySelector('textarea')?.focus();
    }
  }, [isAiToolsVisible])

  return (
    <>
      {/* {
        isAiToolsVisible && (
          <AiToolsContainer ref={ref}>
            <Brain size={20} weight='bold' />
            <textarea placeholder="Summarize the last email I received..." />
          </AiToolsContainer>
        )
      } */}
    </>
  )
}
